import React from 'react';
import classNames from 'classnames';
import css from './MockWidget.module.css';
import Spinner from '../../../../../../common/components/Spinner';

type Props = {
  className?: string;
};

export const MockWidget = ({ className }: Props) => {
  return (
    <div className={classNames(className, css.container)}>
      <Spinner
        size={24}
        show={true}
        position="static"
        backgroundColor="transparent"
      />
    </div>
  );
};
